import * as React from 'react';
import {createRef, useState} from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardActions from '@mui/material/CardActions';
import {question, questionSingle} from '../../mockData/question';
import Description from './Description';
import QAndAFooter from './QAndAFooter';
import Divider from '@mui/material/Divider';
import QuestionOptions from './QuestionOptions';
import {Link, useNavigate} from 'react-router-dom';
import {FILTERED_POLLS_TYPES} from '../../constants/appConstants';
import {faker} from '@faker-js/faker';
import {getCategoryLink, getFilteredPollsLink, getUserProfileLink} from '../../utils/helper';
import Box from '@mui/material/Box';
import SwipeableViews from 'react-swipeable-views';
import Advertisement from '../common/Advertisement';
import CardHeaderAction from './CardHeaderAction';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import {useScreenshot} from 'use-react-screenshot';
import PointsEarnedPerPoll from './PointsEarnedPerPoll';
import ReportedPoll from './ReportedPoll';
import AppAvatar from './AppAvatar'

export default function QuestionCard({showOnlyResults, showEditOption, isSingle, quesAndAns = question(), withBoost = false}) {
  const [isSkipped, setIsSkipped] = useState(false)
  const navigate = useNavigate();
  const ref = createRef(null);
  const [image, takeScreenShot] = useScreenshot();

  const renderSubHeader = (relativeDate, category, questionType) => {
    return <>
      {relativeDate} ago · {questionType} · <Link to={getCategoryLink(category)}>{category}</Link>
    </>
  }

  const renderCreatedBy = (createdBy) => {
    return <>
      <Typography variant="subtitle2" gutterBottom onClick={() => {
        navigate(getUserProfileLink())
      }}>
        {createdBy}
      </Typography>
    </>
  }


  return (
    <>
      <Box sx={{pr: 1, pl: 1, pt: 1, background: 'lightgrey'}}>
        {quesAndAns.map((qAndA, index) => {
          const {createdDate, title, createdBy, description, category, imageUrl, hashtags, questionType} = qAndA
          if (index === 1 && isSkipped) {
            return <Card variant={'outlined'} sx={{mb: 2}}>
              <Alert severity="info">Skipped!
                <Link to={getFilteredPollsLink(FILTERED_POLLS_TYPES.SKIPPED_POLLS)}> View all </Link> skipped items
              </Alert>
            </Card>
          }

          return <Box sx={{mb: 2}}>
            <ReportedPoll isMyPolls={withBoost}/>
            <Card variant={'outlined'}>
              <CardHeader
                avatar={<AppAvatar/>}
                action={<CardHeaderAction handleSkip={setIsSkipped} showEditOption={showEditOption}/>}
                title={renderCreatedBy(createdBy)}
                subheader={renderSubHeader(createdDate, category, questionType)}
              />

              <div ref={ref}>
                <Stack sx={{ml: 2}}>
                  <Typography variant="h6" gutterBottom>
                    {title} ?
                  </Typography>
                </Stack>
              </div>
              {(imageUrl && imageUrl.length > 0) && <>
                <SwipeableViews style={{marginBottom: '10px'}}>
                  {imageUrl.map(url => {
                    return <CardMedia
                      component="img"
                      image={url}
                      alt={faker.person.firstName()}
                    />
                  })}
                </SwipeableViews>
                <hr/>
              </>
              }
              <PointsEarnedPerPoll isMyPolls={withBoost}/>
              <Description description={description} hashtags={hashtags}/>
              <Divider sx={{mb: 1}}/>
              <QuestionOptions {...qAndA} showOnlyResults={showOnlyResults} questionIndex={index.toString()}/>
              <Divider sx={{mb: 1}}/>

              <CardActions disableSpacing>
                <QAndAFooter
                  handleSkip={setIsSkipped} resultImage={image} screenshotRef={ref}
                  showEditOption={showEditOption}
                  withBoost={withBoost || isSingle}/>
              </CardActions>
            </Card>
            {index % 3 === 0 && <Advertisement/>}
          </Box>
        })}
      </Box>
    </>
  );
}
